
import ArrangeSquare2 from "../../../assets/outline/ArrangeSquare2.svg";

import { IconProps } from "../../../types";

const cx = require('classnames');

export default function ArrangeSquare2Icon({ className, dataTestid = "ArrangeSquare2Icon", ...rest }: IconProps) {
  const classes = cx(className);

  return (
    <ArrangeSquare2 data-testid={dataTestid} className={classes} {...rest} />
  );
}
